import { constants as config, kwls as kwlsConfig } from '@config';
import BaseView from './base';
import searchOptionsTemplate from './search-options.hbs';
import detailsTemplate from './search-results/kwls-details.hbs';
import kwlsSearchResults from './kwls-search-results';
import restrictionFacade from '../../../facade/restrictions/restrictions';
import designFacade from '../../../facade/design/design';

module.exports = BaseView.extend({
  type: 'kwls',
  placeHolderUrl: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',
  addedThumbnails: [],

  thumbSize: {
    width: 90,
    height: 90
  },

  events: _.extend({
    'click .item button': 'openPropertyDetails',
    'click .items-container .header span': 'clickItemsContainerHeader',
    'keyup input[name=kwls-details-search]': 'searchKlwsDetails',
    'click input[name=kwls-details-search]': 'searchKlwsDetails',
    'click .texts-header': 'showSearchBox',
    'click .images-header': 'showSearchBox',
    'click .back-link': 'closeDetails'
  }, BaseView.prototype.events),

  initialize: function () {
    _.bindAll(this, 'clickItemsContainerHeader', 'showPropertyItems');

    this.imageProxy = 'https://cflare.smarteragent.com/rest/Resizer?sig_id=69';
    BaseView.prototype.initialize.call(this);

    if (INKIVE.C.BOOK.external_reference) {
      this.preselected = true;
      this.selectOption(this.getSearchOptions().find('[data-key="key"]'));
      const $searchInput = this.$el.siblings('.search-container').find('input');
      $searchInput.val(INKIVE.C.BOOK.external_reference);
      this.search($searchInput);
    }
  },

  search: function ($searchInput) {
    this.addedThumbnails = [];
    BaseView.prototype.search.call(this, $searchInput);
  },

  closeDetails: function (event) {
    const $backButton = $(event.target);
    $backButton.closest('.inner-tabs').find('.search-options').css('display', 'none');
  },

  searchClickEvent: function (event) {
    this.$searchOptions && this.$searchOptions.toggle();
  },

  selectSearchOptionEvent: function (event) {
    const $target = $(event.currentTarget);
    const $options = this.getSearchOptions().find('> div');

    $target.is($options) && this.selectOption($target, $options);
    $options.closest('.search-container').children('input').focus();

    $options.closest('.search-options').css('display', 'none');
  },

  selectOption: function ($target, $options) {
    $options = $options || this.getSearchOptions().find('> div');
    const $input = this.getSearchOptions().siblings('input');
    let $option = $options.find('.desygner-icon-check');

    if (!$option.length) {
      $option = $('<i class="desygner-icon-check"></i>');
    }

    $options.removeClass('selected');
    $option.prependTo($target);
    $target.addClass('selected');

    $input.attr('placeholder', $target.text().trim());
  },

  getSearchOptions: function () {
    if (!this.$searchOptions) {
      this.$searchOptions = $(searchOptionsTemplate({ type: 'kwls', isKwls: true }));
    }

    return this.$searchOptions;
  },

  getSearchUrl: function (val) {
    let searchKey = '';
    const searchType = this.getSearchOptions().find('.selected').data('key');

    switch (searchType) {
      case 'mls':
        searchKey = 'mls_number';
        break;

      case 'key':
        searchKey = 'list_key';
        break;

      case 'list_kw_uid':
        searchKey = 'list_agent_office.list_agent_full_name';
        break;

      case 'co_list_kw_uid':
        searchKey = 'co_list_agent_office.co_list_agent_full_name';
        break;

      case 'list_address':
      default:
        searchKey = 'list_address.full_street_address';
    }

    const url = `${CONFIG.desygner_api}brand/companies/kw/content-providers/kw/search?search_term=${val}&search_key=${searchKey}&offset=`;

    // if(INKIVE.C.USER['kw_uid']) {
    //   url += '&filter[list_kw_uid][is]=' + INKIVE.C.USER['kw_uid'];
    //   url += '&filter[co_list_kw_uid][is]=' + INKIVE.C.USER['kw_uid'];
    // }

    return url;
  },
  mapResult: function (item) {
    return kwlsSearchResults.mapResult(item);
  },

  addThumbnail: function (item) {
    if (_.includes(this.addedThumbnails, item.id)) {
      return;
    }

    if (item.thumbnail !== this.placeHolderUrl) {
      item.thumbnail = this.imageProxy + '&width=' + this.thumbSize.width + '&url=' + encodeURIComponent(item.thumbnail);
    }

    const imageLoadedCallback = _.bind(function (status) {
      item.thumbnail = status === INKIVE.C.Status.success ? item.thumbnail : this.placeHolderUrl;
      BaseView.prototype.addThumbnail.call(this, item);
      this.$el.find('[data-id=' + item.list_uuid + ']').data('item', item);
      this.addedThumbnails.push(item.id);

      if (this.preselected) {
        this.selectOption(this.getSearchOptions().find('[data-key="address"]'));
        this.$el.find('[data-id=' + item.list_uuid + ']').find('button').click();
        this.preselected = false;
      }
    }, this);

    INKIVE.ImagesFactory.smartLoad(item.thumbnail, this.thumbSize, imageLoadedCallback, false);
  },

  openPropertyDetails: function (event) {
    const $target = $(event.currentTarget);
    this.itemDetails = $target.closest('.item').data().item;
    const $detailsContainer = $target.closest('.kwls-content').siblings('.kwls-details');

    this.checkCanReplace();
    $detailsContainer.html(detailsTemplate({
      item: this.itemDetails,
      canUseImages: this.canUseImages,
      canUseText: this.canUseText
    }));
    $detailsContainer.find('.antiscroll-wrap').antiscroll();

    $detailsContainer.css('left', 0);
    $detailsContainer.find('.back-link').on('click', function () {
      INKIVE.SettingsFactory.set({ external_reference: null }).then(_.bind(function () {
        INKIVE.C.BOOK.external_reference = null;
      }, this));

      $detailsContainer.css('left', 315);
    });

    this.clickItemsContainerHeader();
    INKIVE.SettingsFactory.set({ external_reference: this.itemDetails.list_key }).then(_.bind(function () {
      INKIVE.C.BOOK.external_reference = this.itemDetails.list_key;
    }, this));
  },

  checkCanReplace: function () {
    this.canUseImages = restrictionFacade.isFunctionalityAllowed('image_add') ||
      restrictionFacade.isFunctionalityAllowed('image_content') || canUse('image');
    this.canUseText = restrictionFacade.isFunctionalityAllowed('text_add') || canUse('text');

    function canUse (type) {
      const tool = INKIVE.Tool.getInstance();
      const elems = tool.editor.canvas.getSelectedElems();

      if (elems.length === 1 && designFacade.get(elems[0].id).type === type) {
        const restrictionName = type === 'text' ? 'text_change_content' : 'image_content';

        return restrictionFacade.isActionAllowed(restrictionName, elems[0].id) ? 'onlyReplace' : false;
      }
    }
  },

  clickItemsContainerHeader: function (event) {
    const defaultHeader = this.$el.find('.kwls-details').find(this.canUseImages ? '.images-header' : '.texts-header');
    const $target = event ? $(event.currentTarget) : defaultHeader;

    if ($target.is('.active')) {
      return;
    }

    $target.siblings().removeClass('active');
    $target.addClass('active');

    this.showPropertyItems($target.data('key'));
  },

  showPropertyItems: function (tab) {
    this.selectedTab = tab;
    const $parent = this.$el.find('.kwls-details').find('.items-content');
    let $container = $parent.find('.' + tab);

    $parent.find('>div').hide();

    if ($container.length) {
      $container.show();
      tab === 'images' && $container.find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
      return;
    }

    $container = $('<div class="' + tab + '"/>').appendTo($parent);

    INKIVE.Modal.loader($container);
    this.$el.find('[data-search-filter]').show();
    tab && kwlsSearchResults['showProperty' + tab.charAt(0).toUpperCase() + tab.slice(1)]($container, this);
  },

  searchKlwsDetails: function (event) {
    const $target = $(event.currentTarget);
    const val = $target.val();

    event.key === 'Enter' && event.preventDefault();

    this.$el.find('[data-search-filter]').toggle(!val);
    val && this.$el.find('[data-search-filter*=' + val + ']').show();

    this.$el.find('.images').find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
    this.refreshAntiscroll();
  },

  showSearchBox: function (event) {
    const $target = $(event.currentTarget);
    const $search = $target.closest('.antiscroll-inner').find('.search-container');

    if ($target.is('span.texts-header')) {
      $target.closest('.kwls-details').find('.search-options-container').remove();
      $target.closest('.search-options-container').find('.search-options').css('display', 'none');
    }
    $search.toggleClass('search-container-show');
  },

  closeSearchEvent: function (event) {
    BaseView.prototype.closeSearchEvent.call(this, event);
    this.addedThumbnails = [];
    INKIVE.C.BOOK.external_reference = null;
    this.preselected = false;
  }
});
